import { Skeleton, Stack, Box } from "@mui/material";

export const SLSAPayPlanLayerReloader = () => {
	return (
		<Stack direction={"row"} spacing={2} ml={-2}>
			<Stack>
				<Skeleton className="!rounded-md" animation="wave" variant="rectangular" width={5} height={180} />
			</Stack>
			<Stack>
				<div>
					<Skeleton
						sx={{
							marginBottom: "0.2rem",
							borderRadius: "5px 5px 5px 5px",
						}}
						animation="wave"
						variant="rectangular"
						width={280}
						height={18}
					/>
				</div>
				<div style={{ paddingTop: "5px" }}>
					<Skeleton
						sx={{
							marginBottom: "0.2rem",
							borderRadius: "5px 5px 5px 5px",
						}}
						animation="wave"
						variant="rectangular"
						width={160}
						height={15}
					/>
				</div>
				<div>
					<Box
						mb={-1}
						mt={1.5}
						sx={{
							display: "flex",
							alignItems: "center",
							columnGap: 1.5,
						}}
					>
						{Array.from({ length: 3 }).map((_, i) => (
							<Skeleton
								key={i}
								sx={{
									borderRadius: "6px",
								}}
								variant="rectangular"
								width={85}
								height={10}
							/>
						))}
					</Box>
					<Box
						mb={-1}
						mt={1.5}
						sx={{
							display: "flex",
							alignItems: "center",
							columnGap: 0.5,
						}}
					>
						{Array.from({ length: 6 }).map((_, i) => (
							<Skeleton
								key={i}
								sx={{
									borderRadius: "6px",
									marginLeft: "3px",
								}}
								variant="rectangular"
								width={40}
								height={10}
							/>
						))}
					</Box>

					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 2,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={320}
							height={15}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 0.5,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={320}
							height={15}
						/>
					</Box>
				</div>
				<div>
					<div style={{ paddingTop: "10px" }}>
						<Skeleton
							sx={{
								marginBottom: "0.1rem",
								borderRadius: "5px 5px 5px 5px",
							}}
							animation="wave"
							variant="rectangular"
							width={160}
							height={15}
						/>
					</div>
					<Box
						mb={-1}
						mt={1.5}
						sx={{
							display: "flex",
							alignItems: "center",
							columnGap: 1.5,
						}}
					>
						{Array.from({ length: 3 }).map((_, i) => (
							<Skeleton
								key={i}
								sx={{
									borderRadius: "6px",
								}}
								variant="rectangular"
								width={85}
								height={10}
							/>
						))}
					</Box>
					<Box
						mb={-1}
						mt={1.5}
						sx={{
							display: "flex",
							alignItems: "center",
							columnGap: 1,
						}}
					>
						{Array.from({ length: 6 }).map((_, i) => (
							<Skeleton
								key={i}
								sx={{
									borderRadius: "6px",
								}}
								variant="rectangular"
								width={40}
								height={10}
							/>
						))}
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 2,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={320}
							height={15}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 0.5,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={320}
							height={15}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 0.5,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={320}
							height={15}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 0.5,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={180}
							height={8}
						/>
					</Box>
				</div>
				<div style={{ paddingTop: "10px" }}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 0.5,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={180}
							height={18}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 1,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={140}
							height={15}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: 0.5,
							paddingTop: 1,
						}}
					>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={140}
							height={15}
						/>
					</Box>
					<Box
						mb={-1}
						mt={1.5}
						sx={{
							display: "flex",
							alignItems: "center",
							columnGap: 1,
						}}
					>
						{Array.from({ length: 2 }).map((_, i) => (
							<Skeleton
								key={i}
								sx={{
									borderRadius: "6px",
								}}
								variant="rectangular"
								width={85}
								height={10}
							/>
						))}
					</Box>
				</div>
			</Stack>
		</Stack>
	);
};
